/* corex-textil-order.js · Reglas puras del pedido B2B del personalizador de camisetas (sin DOM).
   Importes en céntimos. Precios profesionales = precios contextuales B2B que pinta Liquid; PVP = precio base
   (endpoint perso-prices para las impresiones). Aquí no hay ningún precio ni descuento escrito a mano:
   la tarifa de impresiones sale de corex.personalizacion (qué variante cubre 1, 2 o 3 impresiones de cada tipo),
   el tramo de volumen de corex.volume_tiers y el mínimo textil replica la validación corex-textil-minimo. */
(function (global) {
  'use strict';

  /* Grupo de corex.personalizacion → tipo de impresión del editor. */
  var GROUP_KIND = { 'dtf-peq': '10x10', 'dtf-std': '30x40', 'dtf-grande': '40x50', 'dtf-mangas': 'manga' };
  var KIND_LABEL = { '10x10': 'Pequeñas 10×10', '30x40': 'Standard 30×40', '40x50': 'Grande 40×50', manga: 'Mangas' };
  var KIND_ORDER = ['10x10', '30x40', '40x50', 'manga'];
  var MIN_TEXTIL_DEFAULT = 30;

  /* { kind: { n: variantId } } desde corex.personalizacion: n = nº de áreas que cubre la opción (la primera gana). */
  function tariffFromConfig(config) {
    var out = {};
    ((config && config.grupos) || []).forEach(function (g) {
      var kind = GROUP_KIND[g.id];
      if (!kind) return;
      out[kind] = out[kind] || {};
      (g.opciones || []).forEach(function (o) {
        var n = (o.areas || []).length;
        if (n > 0 && o.variant_id && !out[kind][n]) out[kind][n] = o.variant_id;
      });
    });
    return out;
  }

  /* Reparte n impresiones en paquetes de como mucho `max` (4 con máx. 3 → [3, 1]). */
  function splitPacks(n, max) {
    var out = [];
    if (!(max > 0)) return out;
    for (var left = n; left > 0; left -= Math.min(left, max)) out.push(Math.min(left, max));
    return out;
  }

  /* Recuento por tipo de las impresiones que se imprimen (con alguna capa y tamaño de cobro).
     impresiones: [{ vista, tamano, capas }] del estado del editor; tamano = tamaño de cobro automático
     ('10x10', '30x40', '40x50', 'manga' o null si supera el máximo, que no se puede pedir). */
  function printKind(p) {
    if (!(p.capas > 0) || !p.tamano) return null;
    return p.vista === 'manga_izq' || p.vista === 'manga_der' ? 'manga' : p.tamano;
  }
  function countPrints(impresiones) {
    return (impresiones || []).reduce(function (acc, p) {
      var kind = printKind(p);
      if (kind) acc[kind] = (acc[kind] || 0) + 1;
      return acc;
    }, {});
  }
  /* Ahorro por prenda (céntimos) si la impresión p bajara al tamaño `to`: diferencia de precio de impresiones
     con los mismos packs de la tarifa. null si no se puede calcular. */
  function downsizeSaving(impresiones, p, to, tariff, prices) {
    var from = printKind(p);
    if (!from || from === to) return null;
    var now = countPrints(impresiones), alt = Object.assign({}, now);
    alt[from] -= 1;
    if (!alt[from]) delete alt[from];
    alt[to] = (alt[to] || 0) + 1;
    var a = printGroups(now, tariff, prices), b = printGroups(alt, tariff, prices);
    if (a.missing.length || b.missing.length) return null;
    return sum(a.groups, 'price') - sum(b.groups, 'price');
  }

  /* Variantes de impresión por prenda. prices: { variantId: { price, pvp } } (céntimos; pvp null si no se sabe).
     Devuelve { groups: [{ kind, label, count, items: [{ variantId, n, price, pvp }], price, pvp }], missing: [kind] }. */
  function printGroups(counts, tariff, prices) {
    var groups = [], missing = [];
    KIND_ORDER.forEach(function (kind) {
      var count = counts[kind] || 0;
      if (!count) return;
      var options = tariff[kind] || {}, max = Math.max.apply(null, Object.keys(options).map(Number).concat([0]));
      var items = splitPacks(count, max).map(function (n) {
        var id = options[n], pr = prices[id] || {};
        return { variantId: id || null, n: n, price: pr.price == null ? null : pr.price, pvp: pr.pvp == null ? null : pr.pvp };
      });
      if (!items.length || items.some(function (it) { return it.price == null; })) missing.push(kind);
      groups.push({
        kind: kind, label: KIND_LABEL[kind], count: count, items: items,
        price: sum(items, 'price'), pvp: items.every(function (it) { return it.pvp != null; }) ? sum(items, 'pvp') : null
      });
    });
    return { groups: groups, missing: missing };
  }
  function sum(list, key) { return list.reduce(function (s, x) { return s + (x[key] || 0); }, 0); }
  /* El valor común de la lista, o null si está vacía o hay valores distintos. */
  function sameValue(list) {
    return list.length && list.every(function (x) { return x === list[0]; }) ? list[0] : null;
  }

  /* Tramo de volumen como corex-volume-discount: el mayor tramo con min ≤ unidades del producto. */
  function volumeTier(tiers, qty) {
    var picked = null;
    (tiers || []).filter(function (t) { return typeof t.min === 'number' && typeof t.pct === 'number'; })
      .sort(function (a, b) { return a.min - b.min; })
      .forEach(function (t) { if (qty >= t.min) picked = t; });
    return picked;
  }
  function nextTier(tiers, qty) {
    return (tiers || []).filter(function (t) { return t.min > qty; }).sort(function (a, b) { return a.min - b.min; })[0] || null;
  }

  /* Mínimo textil como corex-textil-minimo: textil del carrito + matriz; 0 o ≥ mínimo no bloquea; tag exento. */
  function minimumCheck(opts) {
    var min = opts.min > 0 ? opts.min : MIN_TEXTIL_DEFAULT, total = (opts.cartTextil || 0) + (opts.matrix || 0);
    var blocked = !opts.exempt && total > 0 && total < min;
    return { min: min, total: total, blocked: blocked, faltan: blocked ? min - total : 0, exempt: !!opts.exempt };
  }

  /* Matriz: { variantId: qty }. Limita al stock y devuelve la cantidad aceptada y si se ha recortado. */
  function clampQty(raw, stock, available) {
    var n = Math.floor(Number(String(raw).replace(',', '.')));
    if (!available || !(n > 0)) return { qty: 0, clipped: false };
    return n > stock ? { qty: stock, clipped: true } : { qty: n, clipped: false };
  }
  /* Totales de la matriz. variants: [{ id, color, talla }] */
  function matrixTotals(variants, qtys) {
    var byColor = {}, bySize = {}, total = 0;
    variants.forEach(function (v) {
      var n = qtys[v.id] || 0;
      if (!n) return;
      byColor[v.color] = (byColor[v.color] || 0) + n;
      bySize[v.talla] = (bySize[v.talla] || 0) + n;
      total += n;
    });
    return { byColor: byColor, bySize: bySize, total: total };
  }

  /* Precio del pedido.
     opts: { variants: [{ id, price, pvp }], qtys, counts, tariff, printPrices, tiers, cartSameProduct }
     pvp de la prenda = metafield de variante corex.pvp (precio base); null si la variante no lo tiene.
     Descuento de volumen como en el carrito real: la función corex-volume-discount da un % y Shopify lo aplica por
     unidad, redondeado a céntimos (comprobado: 20 × 5,45 € al −5 % → 20 × 5,18 € = 103,60 €). */
  function priceOrder(opts) {
    var lines = opts.variants.filter(function (v) { return (opts.qtys[v.id] || 0) > 0; }).map(function (v) {
      var qty = opts.qtys[v.id];
      return { id: v.id, qty: qty, price: v.price, pvp: v.pvp == null ? null : v.pvp, subtotal: qty * v.price };
    });
    var units = lines.reduce(function (s, l) { return s + l.qty; }, 0);
    var garments = sum(lines, 'subtotal');
    var tierQty = units + (opts.cartSameProduct || 0);
    var tier = volumeTier(opts.tiers, tierQty);
    var volume = tier ? lines.reduce(function (s, l) { return s + l.qty * Math.round(l.price * tier.pct / 100); }, 0) : 0;
    var pg = printGroups(opts.counts || {}, opts.tariff || {}, opts.printPrices || {});
    var printUnit = sum(pg.groups, 'price'), printsTotal = printUnit * units;
    var unitPrice = sameValue(opts.variants.map(function (v) { return v.price; }));
    /* PVP de la prenda (corex.pvp): solo si todas las variantes lo tienen y es el mismo; si falta en alguna, sin tachar. */
    var unitPvp = opts.variants.every(function (v) { return v.pvp != null; }) ? sameValue(opts.variants.map(function (v) { return v.pvp; })) : null;
    var garmentPvpKnown = lines.length > 0 && lines.every(function (l) { return l.pvp != null; });
    var printPvpKnown = pg.groups.every(function (g) { return g.pvp != null; });
    var printPvpUnit = printPvpKnown ? sum(pg.groups, 'pvp') : null;
    var perGarment = unitPrice == null ? null : unitPrice + printUnit;
    /* Unitario con el % del tramo sobre la prenda, redondeado a céntimos (igual que el carrito, por unidad).
       roundingDiff = total − unitario × unidades: 0 con un solo precio; la nota solo sale si alguna vez no cuadra. */
    var unitPriceNet = unitPrice == null ? null : unitPrice - (tier ? Math.round(unitPrice * tier.pct / 100) : 0);
    var perGarmentNet = unitPriceNet == null ? null : unitPriceNet + printUnit;
    var perGarmentPvp = unitPvp == null || printPvpUnit == null ? null : unitPvp + printPvpUnit;
    var total = garments - volume + printsTotal;
    var pvpTotal = garmentPvpKnown && printPvpKnown
      ? lines.reduce(function (s, l) { return s + l.qty * l.pvp; }, 0) + printPvpUnit * units : null;
    return {
      units: units, lines: lines, garments: garments, unitPrice: unitPrice, unitPriceNet: unitPriceNet, unitPvp: unitPvp,
      tier: tier, tierQty: tierQty, nextTier: nextTier(opts.tiers, tierQty), volume: volume,
      groups: pg.groups, missing: pg.missing, printUnit: printUnit, printsTotal: printsTotal,
      perGarment: perGarment, perGarmentNet: perGarmentNet, perGarmentPvp: perGarmentPvp,
      perGarmentSavings: perGarmentPvp == null || perGarmentNet == null ? null : perGarmentPvp - perGarmentNet,
      roundingDiff: perGarmentNet == null || !units ? 0 : total - perGarmentNet * units,
      total: total, pvpTotal: pvpTotal, savings: pvpTotal == null ? null : pvpTotal - total
    };
  }

  var api = {
    GROUP_KIND: GROUP_KIND, KIND_LABEL: KIND_LABEL, MIN_TEXTIL_DEFAULT: MIN_TEXTIL_DEFAULT,
    tariffFromConfig: tariffFromConfig, splitPacks: splitPacks, printKind: printKind, countPrints: countPrints, printGroups: printGroups,
    downsizeSaving: downsizeSaving,
    volumeTier: volumeTier, nextTier: nextTier, minimumCheck: minimumCheck, clampQty: clampQty, matrixTotals: matrixTotals,
    priceOrder: priceOrder
  };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.CorexTextilOrder = api;
})(this);
